<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import fileTypeEnum from '../enums/fileType'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fileForm: () => import('../forms/FileForm'),
                saleForm: () => import('../forms/SaleForm'),
                fields: [
                    { type: 'autocomplete', text: 'Sale', value: 'saleId', rules: [v => !!v || 'Sale is required'], isRequired: true, form: () => import('./SaleForm'), apiMethod: 'Sales', claim: 'Sales' },
                    { type: 'file', text: 'File', value: 'fileId', rules: [v => !!v || 'File is required'], isRequired: true, form: () => import('./FileForm'), apiMethod: 'Files' },
                    { type: 'enum', text: 'File Type', value: 'fileType', rules: [v => (v !== null && v !== '') || 'File Type is required'], isRequired: true, items: enumService.enumAsSelectList(fileTypeEnum) },
                ],
                apiMethod: 'SaleFiles',
                formTitle: 'Sale File',
            }
        },
    };
</script>
